// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"ff3d63e979e54afd6047","293":"5f4b9e87eb19ac7b7d6b","522":"8956cf63edf9e67d29eb"}[chunkId] + ".js";
};